import script from "./InterFt.vue?vue&type=script&setup=true&lang=js"
export * from "./InterFt.vue?vue&type=script&setup=true&lang=js"

import "./InterFt.vue?vue&type=style&index=0&id=2d15a578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d15a578"]])

export default __exports__